import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Step6State {
    advisorSelection: string
    agentCode: string
}

const initialState: Step6State = {
    advisorSelection: '',
    agentCode: ''
};

const step6Slice = createSlice({
  name: 'MLTC-R3-Step6',
  initialState,
  reducers: {
    updateAdvisorSelection: (state,action: PayloadAction<string>) => {
      state.advisorSelection = action.payload;
    },
    updateAgentCode: (state,action: PayloadAction<string>) => {
        state.agentCode = action.payload;
      },
  }
})

export const { updateAdvisorSelection, updateAgentCode } = step6Slice.actions;

export default step6Slice.reducer;